import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function AccessPage() {
  useEffect(() => {
    document.title = '廿日市の塾 アクセス・場所｜学習塾NICK｜廿日市市大野中央・駐車場完備';

    const setMeta = (name: string, content: string, property?: boolean) => {
      const attr = property ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', '廿日市の塾・学習塾NICKのアクセスページ。廿日市市大野中央四丁目に位置し、廿日市市・宮島・阿品・大竹市からも通いやすい。専用駐車場5台完備。JR大野浦駅から徒歩12分。廿日市市の中学生が多数通塾中。');
    setMeta('keywords', '廿日市 塾 場所,廿日市市大野 学習塾,廿日市 塾 アクセス,廿日市 中学生 塾 近く,学習塾NICK 住所,廿日市 大野 塾');
    setMeta('og:title', '廿日市の塾 アクセス｜学習塾NICK｜廿日市市大野中央', true);
    setMeta('og:description', '廿日市市大野中央の学習塾NICK。廿日市市・宮島・阿品・大竹市からも通いやすい立地。専用駐車場完備で送迎も安心。廿日市市の中学生が多数通塾中。', true);
    setMeta('og:url', `${import.meta.env.VITE_SITE_URL}/access`, true);
    setMeta('twitter:title', '廿日市の塾 アクセス｜学習塾NICK');
    setMeta('twitter:description', '廿日市市大野中央の学習塾NICK。専用駐車場完備で廿日市市・宮島・阿品・大竹市からも通いやすい。');

    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/access`);

    // Schema.org JSON-LD
    const schemaId = 'schema-access-page';
    let schemaEl = document.getElementById(schemaId) as HTMLScriptElement | null;
    if (!schemaEl) {
      schemaEl = document.createElement('script');
      schemaEl.id = schemaId;
      schemaEl.type = 'application/ld+json';
      document.head.appendChild(schemaEl);
    }
    schemaEl.textContent = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "廿日市の塾 アクセス｜学習塾NICK",
      "description": "廿日市市大野中央の学習塾NICK。廿日市市・宮島・阿品・大竹市からも通いやすい立地。専用駐車場完備で送迎も安心。",
      "url": `${import.meta.env.VITE_SITE_URL}/access`,
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "ホーム", "item": `${import.meta.env.VITE_SITE_URL}/` },
          { "@type": "ListItem", "position": 2, "name": "アクセス", "item": `${import.meta.env.VITE_SITE_URL}/access` }
        ]
      },
      "mainEntity": {
        "@type": "LocalBusiness",
        "name": "学習塾NICK",
        "url": `${import.meta.env.VITE_SITE_URL}/`,
        "telephone": "+81-829-78-1638",
        "email": "rising1001110@gmail.com",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "大野中央四丁目４－１６",
          "addressLocality": "廿日市市",
          "addressRegion": "広島県",
          "postalCode": "739-0400",
          "addressCountry": "JP"
        },
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": "34.2918",
          "longitude": "132.2724"
        },
        "hasMap": "https://www.google.com/maps?q=34.2918,132.2724",
        "openingHoursSpecification": [
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
            "opens": "14:00",
            "closes": "22:00"
          },
          {
            "@type": "OpeningHoursSpecification",
            "dayOfWeek": ["Saturday", "Sunday"],
            "opens": "14:00",
            "closes": "22:00"
          }
        ],
        "amenityFeature": [
          { "@type": "LocationFeatureSpecification", "name": "専用駐車場", "value": true },
          { "@type": "LocationFeatureSpecification", "name": "駐輪スペース", "value": true },
          { "@type": "LocationFeatureSpecification", "name": "自習室", "value": true }
        ],
        "areaServed": ["廿日市市", "廿日市市大野", "阿品", "大竹市", "宮島"]
      }
    });

    return () => {
      document.title = '廿日市の塾なら学習塾NICK｜廿日市市の中学生塾・成績アップ・高校受験対策';
      if (canonical) canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL}/`);
      const s = document.getElementById(schemaId);
      if (s) s.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <main className="pt-20">
        {/* Hero Section */}
        <section className="relative py-32 bg-gradient-to-br from-[#4a90e2]/10 via-white to-[#4a90e2]/5">
          <div className="max-w-7xl mx-auto px-6 text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-[#1a2332] mb-6">
              アクセス
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市大野</strong>の学習塾NICK。<strong>廿日市市</strong>、<strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からもアクセス良好です。
            </p>
          </div>
        </section>

        {/* Map Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <div className="bg-[#f8f9fa] rounded-3xl overflow-hidden shadow-xl">
              <div className="h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8&q=34.2918,132.2724&zoom=17"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="学習塾NICK 地図"
                ></iframe>
              </div>

              <div className="p-12">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                  <div>
                    <h2 className="text-3xl font-bold text-[#1a2332] mb-8">
                      教室情報
                    </h2>

                    <div className="space-y-6">
                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-map-pin-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">住所</p>
                          <p className="text-gray-600 leading-relaxed">
                            〒739-0400<br />
                            広島県廿日市市大野中央四丁目４－１６
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-phone-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">電話番号</p>
                          <p className="text-gray-600">
                            <a href="tel:0829-78-1638" className="hover:text-[#4a90e2] transition-colors cursor-pointer">
                              0829-78-1638
                            </a>
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-mail-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">メールアドレス</p>
                          <p className="text-gray-600">
                            <a href="mailto:rising1001110@gmail.com" className="hover:text-[#4a90e2] transition-colors cursor-pointer">
                              rising1001110@gmail.com
                            </a>
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-time-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">開校時間</p>
                          <p className="text-gray-600 leading-relaxed">
                            平日：14:00〜22:00<br />
                            土曜：10:00〜18:00<br />
                            日曜・祝日：休校
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-parking-box-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">駐車場</p>
                          <p className="text-gray-600">
                            専用駐車場完備（5台）<br />
                            送迎時も安心してご利用いただけます
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div>
                    <h2 className="text-3xl font-bold text-[#1a2332] mb-8">
                      アクセス方法
                    </h2>

                    <div className="space-y-6">
                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-train-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">電車でお越しの方</p>
                          <p className="text-gray-600 leading-relaxed">
                            JR山陽本線「大野浦駅」より徒歩12分<br />
                            駅から国道2号線沿いに進み、大野中央交差点を右折
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-bus-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">バスでお越しの方</p>
                          <p className="text-gray-600 leading-relaxed">
                            「大野中央」バス停より徒歩3分<br />
                            広電バス・おおのハートバスが利用可能
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-car-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">お車でお越しの方</p>
                          <p className="text-gray-600 leading-relaxed">
                            国道2号線「大野中央」交差点より車で2分<br />
                            広島岩国道路「大野IC」より車で5分<br />
                            専用駐車場完備で送迎も安心
                          </p>
                        </div>
                      </div>

                      <div className="flex items-start gap-4">
                        <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center flex-shrink-0">
                          <i className="ri-bike-line text-2xl text-[#4a90e2]"></i>
                        </div>
                        <div>
                          <p className="font-bold text-[#1a2332] mb-2 text-lg">自転車でお越しの方</p>
                          <p className="text-gray-600 leading-relaxed">
                            駐輪スペース完備<br />
                            近隣の中学校から自転車で通塾可能
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Area Section */}
        <section className="py-24 bg-[#f8f9fa]">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              廿日市市大野エリアで学習塾を探している方へ
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
              学習塾NICKは、<strong>廿日市市大野</strong>を中心に、周辺地域からも多くの<strong>中学生</strong>が通塾しています
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
              {[
                {
                  area: '廿日市市大野',
                  schools: ['大野中学校', '大野東中学校'],
                  time: '徒歩・自転車圏内'
                },
                {
                  area: '廿日市市中心部',
                  schools: ['七尾中学校', '阿品台中学校'],
                  time: '車で10〜15分'
                },
                {
                  area: '宮島・阿品エリア',
                  schools: ['宮島中学校', '野坂中学校'],
                  time: '車で15〜20分'
                },
                {
                  area: '大竹市',
                  schools: ['大竹中学校', '小方中学校'],
                  time: '車で15〜20分'
                }
              ].map((area, index) => (
                <div
                  key={index}
                  className="bg-white rounded-3xl p-8 hover:shadow-xl transition-all duration-300"
                >
                  <div className="w-14 h-14 bg-[#4a90e2]/10 rounded-2xl flex items-center justify-center mb-6 mx-auto">
                    <i className="ri-map-pin-2-line text-2xl text-[#4a90e2]"></i>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a2332] mb-4 text-center">
                    {area.area}
                  </h3>
                  <div className="mb-4">
                    {area.schools.map((school, idx) => (
                      <p key={idx} className="text-sm text-gray-600 text-center">
                        {school}
                      </p>
                    ))}
                  </div>
                  <p className="text-sm text-[#4a90e2] font-semibold text-center">
                    {area.time}
                  </p>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-3xl p-10">
              <h3 className="text-2xl font-bold text-[#1a2332] mb-6 text-center">
                地域密着型の学習塾として
              </h3>
              <p className="text-gray-600 leading-relaxed text-center max-w-4xl mx-auto mb-8">
                学習塾NICKは、<strong>廿日市市大野</strong>で地域に根ざした<strong>学習塾</strong>として、20年以上にわたり<strong>中学生</strong>の学習をサポートしてきました。<strong>廿日市市</strong>内の各中学校の特性を理解し、学校ごとの<strong>定期テスト対策</strong>や<strong>内申点対策</strong>を行っています。また、広島県の<strong>高校入試</strong>制度を熟知した講師が、<strong>志望校合格</strong>に向けた的確な指導を提供します。
              </p>

              <p className="text-gray-600 leading-relaxed text-center max-w-4xl mx-auto">
                <strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からも多くの生徒が通塾しており、専用駐車場完備で送迎も安心です。<strong>廿日市市</strong>で<strong>学習塾</strong>をお探しの方は、ぜひ一度<strong>無料体験</strong>にお越しください。
              </p>
            </div>
          </div>
        </section>

        {/* Nearby Schools Section */}
        <section className="py-24 bg-white">
          <div className="max-w-7xl mx-auto px-6">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a2332] mb-4 text-center">
              通塾している生徒の主な中学校
            </h2>
            <p className="text-gray-600 text-center mb-16 max-w-3xl mx-auto leading-relaxed">
              <strong>廿日市市</strong>を中心に、周辺地域の中学校から多くの生徒が通っています
            </p>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
              {[
                '大野中学校',
                '大野東中学校',
                '七尾中学校',
                '阿品台中学校',
                '野坂中学校',
                '宮島中学校',
                '大竹中学校',
                '小方中学校',
                '佐伯中学校',
                '四季が丘中学校',
                '廿日市中学校',
                'その他周辺中学校'
              ].map((school, index) => (
                <div
                  key={index}
                  className="bg-[#f8f9fa] rounded-2xl p-6 text-center hover:shadow-lg transition-all duration-300"
                >
                  <p className="text-gray-700 font-medium">{school}</p>
                </div>
              ))}
            </div>

            <div className="mt-16 text-center">
              <p className="text-gray-600 mb-8 max-w-3xl mx-auto leading-relaxed">
                各中学校の<strong>定期テスト</strong>の出題傾向を分析し、学校別の対策を実施しています。<strong>廿日市市</strong>の<strong>中学生</strong>の<strong>成績アップ</strong>と<strong>志望校合格</strong>を全力でサポートします。
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-24 bg-[#1a2332]">
          <div className="max-w-4xl mx-auto px-6 text-center">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6">
              まずは無料体験からお気軽にご相談ください
            </h2>
            <p className="text-white/80 text-lg mb-10 leading-relaxed">
              <strong>廿日市市大野</strong>の学習塾NICKでは、<strong>無料体験授業</strong>を随時受け付けております。教室の雰囲気や指導方法を実際に体感していただけます。<strong>廿日市市</strong>、<strong>宮島</strong>、<strong>阿品</strong>、<strong>大竹市</strong>など周辺地域からもお気軽にお越しください。
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Link
                to="/trial#trial-form-section"
                className="bg-[#4a90e2] text-white px-10 py-5 rounded-full text-lg font-semibold hover:bg-[#3a7bc8] transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                無料体験に申し込む
                <i className="ri-arrow-right-line text-xl"></i>
              </Link>
              <a
                href="tel:0829-78-1638"
                className="bg-white text-[#1a2332] px-10 py-5 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all hover:scale-105 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line text-xl"></i>
                電話で問い合わせる
              </a>
            </div>

            <div className="flex justify-center gap-6">
              <a
                href="https://lin.ee/Od9tigSF"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/80 hover:text-white transition-colors flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-line-fill text-2xl"></i>
                <span>LINEで相談</span>
              </a>
              <a
                href="mailto:rising1001110@gmail.com"
                className="text-white/80 hover:text-white transition-colors flex items-center gap-2 cursor-pointer"
              >
                <i className="ri-mail-line text-2xl"></i>
                <span>メールで相談</span>
              </a>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
